const features = [
  {
    icon: "ri-shield-check-line",
    title: "Quality Guaranteed",
    desc: "Every product on HipoBuy 2026 is verified for quality. We partner only with trusted sellers who meet our strict standards.",
    stat: "100%",
    statLabel: "Verified",
  },
  {
    icon: "ri-truck-line",
    title: "Fast Global Shipping",
    desc: "HipoBuy shipping delivers worldwide with full tracking. Most orders arrive within 7-15 business days with express options.",
    stat: "150+",
    statLabel: "Countries",
  },
  {
    icon: "ri-lock-line",
    title: "Secure Payments",
    desc: "Shop with confidence using our encrypted payment system. Multiple payment methods accepted for your convenience.",
    stat: "256-bit",
    statLabel: "SSL Secure",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 Support",
    desc: "Our dedicated support team is available around the clock to help with any questions about your HipoBuy 2026 orders.",
    stat: "24/7",
    statLabel: "Available",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Best Prices",
    desc: "HipoBuy 2026 offers the most competitive prices on top-quality fashion. Get luxury looks without the luxury price tag.",
    stat: "50%",
    statLabel: "Avg. Savings",
  },
  {
    icon: "ri-refresh-line",
    title: "Easy Returns",
    desc: "Not satisfied? Our hassle-free 30-day return policy ensures you can shop with complete peace of mind on every purchase.",
    stat: "30",
    statLabel: "Day Returns",
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-20 md:py-24 bg-stone-950 text-white overflow-hidden relative">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/5 rounded-full translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header */}
        <div className="max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-amber-500"></span>
            <span className="text-amber-500 text-xs font-bold uppercase tracking-[0.2em]">Why HipoBuy 2026</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black leading-tight mb-4">
            Why Thousands Choose<br />
            <span className="text-amber-400">HipoBuy 2026</span>
          </h2>
          <p className="text-stone-400 text-base leading-relaxed">
            HipoBuy 2026 is the most trusted platform for top-quality fashion. Here&apos;s what sets us apart from the competition.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((f, idx) => (
            <div
              key={f.title}
              className="group relative bg-stone-900 hover:bg-stone-800 rounded-2xl p-6 border border-stone-800 hover:border-amber-500/30 transition-all duration-300 overflow-hidden"
            >
              {/* Number watermark */}
              <span className="absolute top-4 right-5 text-6xl font-black text-stone-800 group-hover:text-stone-700 transition-colors select-none leading-none">
                {String(idx + 1).padStart(2, "0")}
              </span>

              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-500/10 group-hover:bg-amber-500/20 rounded-xl mb-5 transition-colors">
                  <i className={`${f.icon} text-amber-400 text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-white mb-2">{f.title}</h3>
                <p className="text-stone-400 text-sm leading-relaxed mb-5">{f.desc}</p>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-2xl font-black text-amber-400">{f.stat}</span>
                  <span className="text-stone-500 text-xs uppercase tracking-wider">{f.statLabel}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-12 relative overflow-hidden rounded-2xl bg-gradient-to-r from-amber-500 to-amber-600 p-8 md:p-10">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-1/3 w-48 h-48 bg-white rounded-full translate-y-1/2"></div>
          </div>
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-xl md:text-2xl font-black text-white mb-1">
                Ready to Start Shopping on HipoBuy 2026?
              </h3>
              <p className="text-amber-100 text-sm">
                Join 50,000+ satisfied customers who trust HipoBuy for top-quality fashion.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-amber-600 font-bold rounded-full hover:bg-amber-50 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shopping-bag-3-line"></i>
                </div>
                Buy It Now
              </a>
              <a
                href="https://repsw2c.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-white/60 text-white font-bold rounded-full hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-truck-line"></i>
                </div>
                HipoBuy Shipping
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
